import { CarouselItem } from './types';

export const testimonialsDataES: CarouselItem[] = [
  {
    text: 'Yoga International ofrece una amplia gama de instructores expertos con una gran variedad de estilos. Me gusta la variedad de niveles, duraciones y temas, así como los artículos y los talleres. Definitivamente vale la pena comprar la membresía. Yo siempre se la recomiendo a mis alumnos.',
    name: 'Polly',
    role: 'YI Member',
    stars: 5,
    id: '1',
  },

  {
    text: 'Me encanta Yoga International. Es mi amigo de confianza. Siempre encuentro algo para practicar que se adapta a mis necesidades, ya sean físicas, emocionales o espirituales. Para mí, el mejor sitio de yoga en línea que existe.',
    name: 'Edy',
    role: 'YI Member',
    stars: 5,
    id: '2',
  },
  {
    text: 'Me encanta Yoga International. Es una plataforma muy práctica y fácil de usar. Yo la utilizo todos los días. Poder elegir una clase que se adapte a mi capacidad diaria ha marcado la diferencia. Además, hay una gran variedad de opciones y estilos.',
    name: 'Kim ',
    role: 'YI Member',
    stars: 5,
    id: '3',
  },
  {
    text: 'Soy profesora de yoga, y mi experiencia es que las clases son creativas e innovadoras, aprendo algo nuevo casi siempre. Disfruto practicando y tomando clases con una gran variedad de profesores, que se ha convertido en parte de mi estilo de vida.',
    name: 'Christina',
    role: 'Yoga Teacher',
    stars: 5,
    id: '4',
  },
  {
    text: 'YI ofrece una gran variedad de clases, por lo que siempre encuentro algo para cada momento del día, de la semana y del estado de ánimo que tenga. Además ofrecen meditaciones, artículos interesantes e inspiradores y cursos de educación continua.',
    name: 'Choice',
    role: 'Yoga Teacher ',
    stars: 5,
    id: '5',
  },

  {
    text: 'Como madre de un niño pequeño, no tengo mucho tiempo para ir al gimnasio, pero siempre puedo practicar con Yoga International. Me encanta la variedad de cursos, el gran número de profesores y el subidón de ánimo instantáneo que siento al terminar una clase. Lo recomiendo absolutamente.',
    name: 'Mimi ',
    role: 'Yoga Teacher',
    stars: 5,
    id: '6',
  },
  {
    text: 'Me encanta Yoga International. Es la respuesta al tiempo que me dedico a MI. Como entrenadora personal, instructora de fitness, coach de nutrición y madre a tiempo completo, rara vez tengo tiempo para mí. Con YI, simplemente me conecto, sigo la clase recomendada y voila, estoy en sincronía con mi cuerpo de nuevo.',
    name: 'Natalie ',
    role: 'Yoga + Fitness Instructor',
    stars: 5,
    id: '7',
  },
  {
    text: 'Gran plataforma con una amplia selección de clases de yoga. Suelo ir a clases más vigorosas pero también me alegra mucho encontrar opciones de yoga para embarazadas y postparto.',
    name: 'Sara',
    role: 'YI Member',
    stars: 5,
    id: '8',
  },

  {
    text: 'Me gusta que puedo elegir entre diferentes tipos de clases. De hecho, acabo de descubrir los beneficios del kundalini yoga y me encanta. Puedo elegir fácilmente la duración y el profesor que prefiera. Realmente siento que tengo todo el mundo del yoga siempre conmigo y disponible para cuando lo deseo.',
    name: 'Sami ',
    role: 'YI Member',
    stars: 5,
    id: '9',
  },
  {
    text: 'Wow, no me había dado cuenta de lo mucho que necesitaba una clase de Yin Yoga. Mi estado emocional, espiritual y físico mejoró después de tomar savasana. Gracias por la oportunidad.',
    name: 'Paulina',
    role: 'YI Member',
    stars: 5,
    id: '10',
  },
  {
    text: 'Yoga International es un espacio ideal para crecer y profundizar en tu práctica. Filtros útiles, sugerencias de clases y la posibilidad de realizar un seguimiento de tu progreso y objetivos. Lo recomiendo ampliamente.',
    name: 'Chandra',
    role: 'YI Member',
    stars: 5,
    id: '11',
  },
  {
    text: 'No tengo mucho tiempo para practicar y asistir a clases de yoga en persona, pero gracias a las habilidades de los profesores de Yoga Internacional, me siento como en una clase en vivo todo el tiempo. Soy miembro desde hace mucho tiempo (también soy profesora de yoga) y he participado en muchos cursos estupendos. ¡Lo recomiendo totalmente!',
    name: 'M.',
    role: 'Yoga Teacher',
    stars: 5,
    id: '12',
  },
  {
    text: 'No importa cómo me sienta, siempre hay una clase o meditación para mí. Los filtros son super útiles para encontrar las mejores opciones de tiempo y enfoque. He tomado 4 cursos y actualmente estoy empezando otro, todos ellos valen mucho la pena.',
    name: 'Melissa ',
    role: 'YI Member',
    stars: 5,
    id: '13',
  },
];
